<template>
  <crud-form
    v-model="payload"
    page-title="Editar template"
    :request-class="requestClass"
    :total-group="2"
    navigate-back-route="contacard.communication.templates.list"
    :override-create-payload="overrideCreatePayload"
    :override-edit-payload="overrideEditPayload"
    :override-set-entity-data="overrideSetEntityData"
  >
    <template slot="group-1">
      <form-group>
        <span class="h2Header secondary400 fs26">
          {{ templateName }}
        </span>
      </form-group>
    </template>
    <template
      slot="group-2"
    >
      <v-col
        cols="3"
      >
        <v-row>
          <v-list>
            <v-subheader class="h2Header secondary300 mb-3">
              Tags gerais
            </v-subheader>
            <v-list-item-group
              v-model="selectedItem"
              color="primary"
              style="height: 200px; overflow: auto;"
              class="custom-scroll"
            >
              <v-list-item
                v-for="(item) in tags"
                :key="item.key"
              >
                <v-list-item-content class="py-2">
                  <v-list-item-title
                    class="secondary300 text2 nunitoSansFont"
                    style="white-space: normal"
                    @click="addTagToText(item);"
                    v-text="item.value"
                  />
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-row>
        <v-row>
          <v-divider />
        </v-row>
        <v-row>
          <v-list>
            <v-subheader class="h2Header secondary300 mb-3">
              Tags específicas
            </v-subheader>
            <v-list-item-group
              v-model="selectedItem"
              color="primary"
              style="height: 200px; overflow: auto;"
              class="custom-scroll"
            >
              <v-list-item
                v-for="(item) in tags"
                :key="item.key"
              >
                <v-list-item-content class="py-2">
                  <v-list-item-title
                    class="secondary300 text2 nunitoSansFont"
                    style="white-space: normal"
                    @click="addTagToText(item);"
                    v-text="item.value"
                  />
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-row>
      </v-col>
      <form-group>
        <span class="h2Header secondary300 fs26">Selecione o tipo de comunicação</span>
        <v-row>
          <v-col
            cols="12"
            class="d-flex"
          >
            <v-checkbox
              v-model="payload.push"
              label="Notificação push"
              class="mr-8 body"
              :disabled="payload.isExternalReceiver"
              @change="clearPayloadFields($event, 'Push')"
            />
            <v-checkbox
              v-model="payload.sms"
              label="SMS"
              class="mr-8 body"
              @change="clearPayloadFields($event, 'Sms')"
            />
            <v-checkbox
              v-model="payload.email"
              label="E-mail"
              class="mr-8 body"
              @change="clearPayloadFields($event, 'Email')"
            />
            <v-checkbox
              v-model="payload.notification"
              label="Notificação"
              class="mr-8 body"
              :disabled="payload.isExternalReceiver"
              @change="clearPayloadFields($event, 'Notification')"
            />
            <v-checkbox
              v-model="payload.pdf"
              label="PDF"
              class="mr-8 body"
              @change="clearPayloadFields($event, 'Pdf')"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-tabs
            v-model="tabs"
            class="mb-8"
          >
            <v-tab
              class="body1"
              style="text-transform: none; letter-spacing: 0"
            >
              Notificação push
            </v-tab>
            <v-tab
              class="body1"
            >
              SMS
            </v-tab>
            <v-tab
              class="body1"
              style="text-transform: none; letter-spacing: 0"
            >
              E-mail
            </v-tab>
            <v-tab
              class="body1"
              style="text-transform: none; letter-spacing: 0"
            >
              PDF
            </v-tab>
          </v-tabs>

          <v-tabs-items
            v-model="tabs"
            class="flex-grow-1"
          >
            <v-tab-item>
              <v-row class="mt-3">
                <v-col cols="11">
                  <v-text-field
                    id="input:titlePush"
                    v-model="payload.titlePush"
                    :rules="[!payload.push ||requiredRule, maxLength(80)]"
                    label="Título"
                    outlined
                    required
                    :disabled="!payload.push"
                  />
                </v-col>
                <v-col cols="11">
                  <v-textarea
                    id="input:bodyPush"
                    ref="bodyPush"
                    v-model="payload.bodyPush"
                    :rules="[!payload.push || requiredRule, maxLength(255)]"
                    label="Mensagem"
                    outlined
                    counter
                    :disabled="!payload.push"
                    @click="selectedTextArea = 'bodyPush'"
                  />
                </v-col>
              </v-row>
            </v-tab-item>

            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <v-row>
                    <v-col cols="11">
                      <v-text-field
                        id="input:titleSms"
                        v-model="payload.titleSms"
                        :rules="[!payload.sms || requiredRule, maxLength(80)]"
                        label="Título"
                        outlined
                        required
                        :disabled="!payload.sms"
                      />
                    </v-col>
                    <v-col cols="11">
                      <v-textarea
                        id="input:bodySms"
                        ref="bodySms"
                        v-model="payload.bodySms"
                        :rules="[!payload.sms || requiredRule, maxLength(160)]"
                        label="Mensagem"
                        outlined
                        :disabled="!payload.sms"
                        counter
                        @click="selectedTextArea = 'bodySms'"
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card flat>
                <form-group>
                  <v-col cols="12">
                    <v-row>
                      <v-text-field
                        id="input:titleEmail"
                        v-model="payload.titleEmail"
                        :rules="[!payload.email || requiredRule, maxLength(255)]"
                        label="Título"
                        outlined
                        required
                        :disabled="!payload.email"
                      />
                    </v-row>
                    <v-row>
                      <v-col
                        cols="12"
                      >
                        <div
                          class="mb-8 d-flex justify-space-between align-start"
                        >
                          <p>Mensagem:</p>
                          <v-dialog
                            v-model="dialog"
                            width="1000"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-show="html"
                                color="primary"
                                v-bind="attrs"
                                v-on="on"
                              >
                                Preview
                              </v-btn>
                            </template>
                            <v-card>
                              <preview-code-modal :html="html" />
                            </v-card>
                          </v-dialog>
                        </div>
                        <v-row>
                          <editor-code
                            ref="codeEditor"
                            class="mb-4"
                            :code="html"
                            @update-code="updateHtml($event)"
                          />
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </form-group>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card flat>
                <form-group>
                  <v-row>
                    <v-col
                      cols="12"
                    >
                      <div
                        class="mb-8 d-flex justify-space-between align-start"
                      >
                        <p>PDF:</p>
                        <v-spacer />
                        <terminate-button
                          v-if="hasDownload"
                          :template="templateName"
                        />
                        <v-dialog
                          v-model="dialogPdf"
                          width="1000"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-show="pdf"
                              color="primary"
                              v-bind="attrs"
                              class="ml-2"
                              v-on="on"
                            >
                              Preview
                            </v-btn>
                          </template>
                          <v-card>
                            <preview-code-modal :html="pdf" />
                          </v-card>
                        </v-dialog>
                      </div>
                      <v-row>
                        <editor-code
                          ref="codeEditor"
                          class="mb-4"
                          :code="pdf"
                          @update-code="updatePdf($event)"
                        />
                      </v-row>
                    </v-col>
                  </v-row>
                </form-group>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-row>
      </form-group>
    </template>
  </crud-form>
</template>

<script>
import CrudForm from 'Arch/components/crud/CrudForm.vue';
import TemplatesRequest from 'Modules/contacard/communication/templates/TemplatesRequest';
import FormGroup from 'Arch/components/crud/components/FormGroup.vue';
import RulesMixin from 'Arch/mixins/RulesMixin';
import TemplateTags from 'Arch/enums/TemplateTags';
import PreviewCodeModal from './components/PreviewCodeModal.vue';
import TerminateButton from './components/TerminateButton.vue';

export default {
  name: 'TemplatesForm',
  components: {
    CrudForm,
    FormGroup,
    PreviewCodeModal,
    TerminateButton,
  },
  mixins: [RulesMixin],
  data: () => ({
    requestClass: TemplatesRequest,
    dialogPdf: null,
    tabs: null,
    html: false,
    pdf: false,
    hasDownload: false,
    payload: {
      id: null,
      email: false,
      titleEmail: '',
      bodyEmail: '',
      push: false,
      titlePush: '',
      bodyPush: '',
      notification: false,
      sms: false,
      titleSms: '',
      bodySms: '',
      pdf: false,
      bodyPdf: '',
      isExternalReceiver: '',
      name: '',
    },
    types: ['Notificação push', 'SMS', 'E-mail'],
    tags: TemplateTags,
    selectedItem: null,
    selectedTextArea: null,
    dialog: null,
  }),
  computed: {
    templateName() {
      return this.payload.name.replace('Template', '');
    },
  },
  methods: {
    overrideSetEntityData(data) {
      this.overrideSetCodeData(data);
      this.handleDisplayDownloadBtn(data);
      return { ...data };
    },
    overrideSetCodeData(data) {
      this.pdf = data.bodyPdf;
      this.html = data.bodyEmail;
    },
    handleDisplayDownloadBtn(data) {
      if (data && data.pdf && data.bodyPdf) {
        this.hasDownload = true;
      }
    },
    overrideCreatePayload(payload) {
      return {
        id: payload.id,
        email: payload.email,
        titleEmail: payload.titleEmail,
        bodyEmail: this.html,
        push: payload.push,
        titlePush: payload.titlePush,
        bodyPush: payload.bodyPush,
        notification: payload.notification,
        sms: payload.sms,
        titleSms: payload.titleSms,
        bodySms: payload.bodySms,
        pdf: payload.pdf,
        bodyPdf: this.pdf,
        name: payload.name,
      };
    },
    overrideEditPayload(payload) {
      return {
        id: payload.id,
        email: payload.email,
        titleEmail: payload.titleEmail,
        bodyEmail: this.html,
        push: payload.push,
        titlePush: payload.titlePush,
        bodyPush: payload.bodyPush,
        notification: payload.notification,
        sms: payload.sms,
        titleSms: payload.titleSms,
        bodySms: payload.bodySms,
        pdf: payload.pdf,
        bodyPdf: this.pdf,
        name: payload.name,
      };
    },
    addTagToText(value) {
      if (this.selectedTextArea) {
        const insert = `{{${value.key}}}`;
        const textarea = this.$refs[this.selectedTextArea].$refs.input;
        const sentence = textarea.value;
        const len = value.length;
        let pos = textarea.selectionStart;
        if (pos === undefined) {
          pos = 0;
        }

        const before = sentence.substr(0, pos);
        const after = sentence.substr(pos, len);

        this.payload[this.selectedTextArea] = `${before} ${insert} ${after}`;
        this.$nextTick().then(() => {
          textarea.selectionEnd = pos + insert.length;
        });
      }
    },
    clearPayloadFields(event, field) {
      if (!event) {
        this.payload[`title${field}`] = '';
        this.payload[`body${field}`] = '';
      }
    },
    updatePdf(value) {
      this.pdf = value;
    },
    updateHtml(value) {
      this.html = value;
    },
  },
};
</script>
<style>
  .v-input--selection-controls__input .v-icon {
    color: #c71d1d !important;
  }

  .custom-scroll::-webkit-scrollbar {
    width: 3px;
  }
  .custom-scroll::-webkit-scrollbar-track {
    background: #FFF;
  }
  .custom-scroll::-webkit-scrollbar-thumb {
    background: #EEE;
    border-radius: 100px;
  }
  .custom-scroll::-webkit-scrollbar-thumb:hover {
    background: #757575;
  }
</style>
